module.exports = __webpack_public_path__ + "static/img/tubka_r.1de3e4b2.png";